var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("program-head", { attrs: { isNeedBack: false } }),
      _vm._v(" "),
      _vm.Programs.length
        ? _c("div", [
            _c(
              "table",
              { staticClass: "table-wrapperNew" },
              _vm._l(_vm.Programs, function (program) {
                return _c("tr", [
                  _c(
                    "td",
                    { staticClass: "main-tab", class: _vm.getBg(program) },
                    [
                      _c("table", [
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "id-num",
                              on: {
                                click: function ($event) {
                                  return _vm.editTrade(program)
                                },
                              },
                            },
                            [_vm._v(_vm._s(program.id))]
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "btcusd" }, [
                            _vm._v(_vm._s(program.asset)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-1" }, [
                            _vm._v("Active"),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-1" }, [
                            _vm._v("Deposited/Committed"),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-1" }, [
                            _vm._v("Last deposit"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td"),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-2" }, [
                            _vm._v(_vm._s(program.type_name)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-2" }, [
                            _vm._v(
                              _vm._s(_vm.getDate(program.start_date)) +
                                " – " +
                                _vm._s(_vm.getDate(program.end_date))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-2" }, [
                            _vm._v(
                              "$" +
                                _vm._s(program.total_deposited) +
                                " / $" +
                                _vm._s(program.committed)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-2" }, [
                            _vm._v("$" + _vm._s(program.lda)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td"),
                          _vm._v(" "),
                          _c("td"),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-3" }, [
                            _vm._v(_vm._s(_vm.getDays(program)) + "d left"),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-3" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  parseFloat(program.committed) -
                                    parseFloat(program.total_deposited)
                                ) +
                                " left"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-3" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getDate(program.ldd) === "Invalid date"
                                  ? ""
                                  : _vm.getDate(program.ldd)
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }